import React, { useState, useRef, useEffect, useContext } from 'react';
import './EarthDateFilter.scss';
import DatePicker from '../../../DatePicker/DatePicker';
import { ReactComponent as Calendar } from '../../../../assets/icons/today-24px.svg'
import { format } from 'date-fns';
import { FilterStore } from '../../../../App';

export default () => {

  const [fromOpen, setFromOpen] = useState(false);
  const [toOpen, setToOpen] = useState(false);


  const { changeEarthDate } = useContext(FilterStore).actions;
  const currentFilter = useContext(FilterStore).filter;

  const currentDate = new Date();

  const [fromDate, setFromDate] = useState(!currentFilter.fromDate ? currentDate : currentFilter.fromDate);
  const [toDate, setToDate] = useState(!currentFilter.toDate ? currentDate : currentFilter.toDate);

  const toRef = useRef();
  const fromRef = useRef();

  const [datePosition, setDatePosition] = useState({
    from: 0,
    to: 0
  });


  useEffect(() => {
    if (fromDate !== toDate && fromDate.getTime() < toDate.getTime()) {
      changeEarthDate(fromDate, toDate);
    } else {
      changeEarthDate(null, null);
    }
  }, [fromDate, toDate])

  const onDateChange = (handler, date, oldDate, closeHandler) => {
    if (date !== oldDate) {
      handler(date);
      closeHandler(false);
    }
  }

  useEffect(() => {
    if (fromRef.current && toRef.current) {
      setDatePosition({
        from: fromRef.current.offsetLeft - 28,
        to: toRef.current.offsetLeft - 28
      })
    }
  }, [fromRef, toRef]);

  return (
    <div className="filter-item">
      <h2 className="filter-item__headline">Earth date</h2>
      <div className="earth-date">
        <div className="earth-date__item">
          <h3 className="earth-date__item__label">From</h3>
          <button
            onClick={() => setFromOpen(!fromOpen)}
            className="earth-date__item__calendar-button"
            ref={fromRef}
          >
            <Calendar />
          </button>
          {fromOpen
            ? (
              <div
                style={{
                  left: datePosition.from
                }}
                className="earth-date__item__date"
              >
                <DatePicker 
                  date={fromDate}
                  onChange={(date) => onDateChange(setFromDate, date, fromDate, setFromOpen)}
                />
              </div>
            )
            : null}
          <div className="earth-date__item__current-date">
            {format(fromDate, 'd.M.yyyy')}
          </div>
        </div>
        <div className="earth-date__item">
          <h3 className="earth-date__item__label">To</h3>
          <button
            onClick={() => setToOpen(!toOpen)}
            className="earth-date__item__calendar-button"
            ref={toRef}
          >
            <Calendar />
          </button>
          {toOpen
            ? (
              <div className="earth-date__item__date">
                <DatePicker
                  onChange={(date) => onDateChange(setToDate, date, toDate, setToOpen)}
                  date={toDate}
                />
              </div>
            )
            : null}
          <div className="earth-date__item__current-date">
            {format(toDate, 'd.M.yyyy')}
          </div>
        </div>
      </div>
    </div>
  )
}